import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { FooterV2Component } from './footer-v2.component';

@NgModule({
  declarations: [
    FooterV2Component,
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    FooterV2Component,
  ],
})
export class FooterV2Module { }
